<template>
  <div>
    <v-overlay :value="loading" :absolute="true" v-if="$route.name !== 'reportPrint'">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <AccountantsReportTemplate v-if="$route.name === 'reportPrint'"
                              :entries="invoices"
                              :totalsCounts="totalsCounts"
                              :reportData="reportData"
                              :from="from"
                              :to="to"
                              :key="'reportTemplateKey' + invoices.length"
                              :companyId="companyId"
                              :currentDateTime="currentDateTime"
                              :accountantName="accountantName"
    />
    <v-card v-else>
      <v-card-title :style="{ backgroundColor: $root.currentTheme.background }">
        {{$t('Reports.Accountants')}}
      </v-card-title>

      <AccountantsTotals :from="from"
                         :to="to"
                         :key="from+to"
                         :accountantId="accountantId"/>

      <v-divider/>
      <ReportActions
        :key="reportsGroupsListKey"
        :userId="accountantId"
        :from="from"
        :to="to"
        :paramsType="$route.params.type"
        :selectedItems="selectedItems"
        :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
        :isSelectedHavePayed="isSelectedHavePayed"
        @create-report-group="createReport"
        @mark-selected-as-paid="markSelectedAsPaid"
        @mark-selected-as-not-paid="markSelectedAsNotPaid"
        @mark-selected-as-payed-and-create-report-group="markSelectedAsPayedAndCreateReportGroup"
        @show-saved-reports="$root.onShowReportsModal"
      />
      <v-layout v-if="$root.isFullFinancialDataAllowedToView" wrap>
        <!-- <v-flex shrink class="text-right text-no-wrap">
          <v-select
            class="ma-1"
            outlined dense
            :items="['All','New','Ready','Verified','Pending','Paid','Underpaid','Not Paid','Overdue']"
            v-model="statusFilter"
            @change="statusFilterChanged"
            :label="$t('Invoices.StatusFilter')"
          />
        </v-flex> -->
        <v-flex shrink>
          <FiltersPanel
            ref="filtersPanel"
            prefix="invoicesReport"
            outlined
            :isExpansionPanel="$root.isMobile"
            :loading="loading"
            :items="[statusFilter, dispatcherFilter, driverFilter, truckFilter, brokerFilter]"
            :key="statusFilter.name + statusFilter.list.length + dispatcherFilter.name + dispatcherFilter.list.length + driverFilter.name + driverFilter.list.length + truckFilter.name + truckFilter.list.length"
            @filterBrokerKeyUp="filterBrokerSearch"
            @change="onFilterChanged"/>
        </v-flex>
        <v-flex>
          <v-text-field
              class="mt-1"
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              outlined dense
              hide-details
          />
        </v-flex>
        <v-flex shrink v-if="$root.isMobile">
            <v-btn class="mt-1 ml-1"
                    @click="$refs.filtersPanel.showFiltersDrawer()">
                    <v-icon>mdi-filter</v-icon>
            </v-btn>
          </v-flex>
        <!--<v-flex shrink shrink>
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>-->
      </v-layout>

      <v-list v-if="$root.isMobile">
        <v-list-item-group
          v-model="selectedItems"
          multiple
          active-class=""
        >
          <template v-for="(item, index) in invoices">
            <v-list-item :key="'invoiceItem' + index" :value="item">
              <template v-slot:default="{ active }">
                <v-list-item-icon>
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-icon>
                <v-list-item-content @click="rowClick(item.id, item.invoiceNumber)">
                  <v-tooltip>
                    <template v-slot:activator="{ on }">
                      <a v-on="on" @click.stop="" >#{{item.invoiceNumber}}</a>
                    </template>
                    <span>{{item.name}}</span>
                  </v-tooltip>
                  L/N: {{!item.loadNumber ? 'N/A' : item.loadNumber}}<br/>
                  {{item.creatorName}}<br/>
                  <v-list-item-subtitle>
                    <a @click.stop="$root.onShowLoadPreview(item.load_id)">#{{item.load_id}}</a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{item.brokerName}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-right">
                  {{item.createdDatePST.substring(0,10)}}<br/>
                  <InvoiceStatusSnippet :item="item"></InvoiceStatusSnippet>

                  ${{item.parentTotal > 0 ? parseFloat(parseFloat(item.total-item.parentTotal).toFixed(2)).toLocaleString() : parseFloat(item.total.toFixed(2)).toLocaleString()}}
                  <template v-if="item.scheduleNumber > 0">#{{item.scheduleNumber}}</template>
                  <template v-if="item.parentReceivedDate > 0">
                    <v-chip small v-if="item.total <= item.amountReceived + item.parentAmountReceived" class="text-no-wrap success" dense>${{parseFloat(item.amountReceived.toFixed(2)).toLocaleString()}}</v-chip>
                    <v-chip small v-else class="text-no-wrap error" dense success>${{parseFloat(item.parentAmountReceived.toFixed(2)).toLocaleString()}}(-${{parseFloat(item.total - item.amountReceived - item.parentAmountReceived).toLocaleString()}})</v-chip>
                  </template>
                  <template v-else-if="item.receivedDate > 0">
                    <v-chip small v-if="item.totalWithoutFees <= item.amountReceived" class="text-no-wrap success" dense>${{parseFloat(item.factReceived.toFixed(2)).toLocaleString()}}</v-chip>
                    <v-chip small v-else class="text-no-wrap error" dense success>${{parseFloat(item.factReceived.toFixed(2)).toLocaleString()}}(-${{parseFloat(item.total - item.amountReceived).toLocaleString()}})</v-chip>
                  </template>
                  <template v-else>
                    <v-chip small class="text-no-wrap warning" dense>
                      ${{parseFloat(item.expectToReceive.toFixed(2)).toLocaleString()}}
                    </v-chip>
                  </template>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider :key="'invoiceDivider' + index"/>
          </template>
        </v-list-item-group>
      </v-list>

      <v-data-table
        v-else
        :headers="headers"
        :items="invoices"
        :search="search"
        :items-per-page="100"
        :footer-props="footer_props"
        v-model="selectedItems"
        height="calc(100vh - 200px)"
        fixed-header
        show-select
        @item-selected="onItemSelected"
        @toggle-select-all="onItemSelected"
        @click:row="rowClick($event.id, $event.invoiceNumber)"
      >

        <template v-slot:item.created="{ item }">
          <v-layout v-if="item.userCreated">
            <v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar v-on="on"
                            @click.stop="$root.onShowUserPreview(item.userCreated, item.creatorName)"
                            style="cursor: pointer;"
                            class="ml-1"
                            :size="32"
                            :color="(item.creatorInitials && !item.creatorAvatar)?'#015aaa':null">
                    <v-img :src="$root.getImageUrl('avatar', item.creatorAvatar)" v-if="item.creatorAvatar"></v-img>
                    <span class="white--text" v-else-if="item.creatorInitials">{{item.creatorInitials}}</span>
                    <v-icon large v-else>account_circle</v-icon>
                  </v-avatar>
                </template>
                <span>{{item.creatorName}}</span>
              </v-tooltip>
            </v-flex>
            <v-flex>
              <template v-if="item.createdDatePST">
                {{item.createdDatePST.substring(0,10)}}
                <br/>
                {{item.createdDatePST.substring(11)}}
              </template>
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:item.sentDate="{ item }">
          <v-layout v-if="item.userSended">
            <v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-avatar v-on="on"
                            @click.stop="$root.onShowUserPreview(item.userSended, item.senderName)"
                            style="cursor: pointer;"
                            class="ml-1"
                            :size="32"
                            :color="(item.senderInitials && !item.senderAvatar)?'#015aaa':null">
                    <v-img :src="$root.getImageUrl('avatar', item.senderAvatar)" v-if="item.senderAvatar"></v-img>
                    <span class="white--text" v-else-if="item.senderInitials">{{item.senderInitials}}</span>
                    <v-icon large v-else>account_circle</v-icon>
                  </v-avatar>
                </template>
                <span>{{item.senderName}}</span>
              </v-tooltip>
            </v-flex>
            <v-flex>
              <template v-if="item.sentDatePST">
                {{item.sentDatePST.substring(0,10)}}
                <br/>
                {{item.sentDatePST.substring(11)}}
              </template>
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:item.broker="{ item }">
          <template v-if="item.broker">
            <div class="text-no-wrap">{{item.brokerName}}</div>
            <div class="text-no-wrap">{{item.terms}}</div>
          </template>
        </template>

        <template v-slot:item.invoiceNumber="{ item }">
          <div v-if="item.invoiceNumber" class="text-no-wrap">
            {{$t('Invoice')}}: <a href="#" @click.stop="$router.push('/invoices/page/'+item.id)">#{{item.invoiceNumber}}</a>
          </div>
          <div v-if="item.loadId" class="text-no-wrap">
            {{$t('Load')}}: <a href="#" @click.stop="$root.onShowLoadPreview(item.loadId)">#{{item.loadId}}</a>
          </div>
        </template>

        <!--<template v-slot:item.dueDate="{ item }">
          {{item.dueDate ? item.dueDate.split('T')[0] : ''}}
        </template>
        <template v-slot:item.created="{ item }">
          {{item.dueDate ? item.created.split('T')[0] : ''}}
        </template>-->
        <!--<template v-slot:item.sentDate="{ item }">
          {{$root.formatDate(item.sentDatePST.substring(0,10))}}
          <br/>
          {{item.sentDatePST.substring(11,19)}}
        </template>-->
        <template v-slot:item.loadUIDAndNumber="{ item }">
          <div class="text-no-wrap">
            Load Number: {{!item.loadNumber ? 'N/A' : item.loadNumber}}
          </div>
          <div class="text-no-wrap">
            <a href="#" @click.stop="$root.route('/users/page/'+item.dispatcherId)">{{item.dispatcherName}}</a>
          </div>
          <!--<div class="text-no-wrap">
            <a @click="$root.route('/loads/page/'+item.load_id)">{{item.loadUID}}</a>
            <v-tooltip bottom v-if="item.loadUID">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click.stop="$root.addNewPageTab('/loads/page/' + item.load_id)" v-if="$root.isLoadsViewAllowed">
                  <v-icon small class="mr-1">mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>{{$t('OpenExternal')}}</span>
            </v-tooltip>
          </div>-->
        </template>

        <template v-slot:item.trucks="{ item }">
          <template v-for="truck in item.trucksData">
            <v-layout :key="item.id +'_truck_' + truck.id">
              <a v-if="$root.isTrucksViewAllowed"
                 @click.stop="$root.route('/trucks/page/' + truck.id)">{{truck.name}}</a>
              <span v-else>{{truck.name}}</span>&nbsp;
            </v-layout>
            <!--</v-layout>-->
          </template>
        </template>
        <template v-slot:item.drivers="{ item }">
          <v-layout>
            <template v-for="driver in item.driversData">
              <v-flex :key="item.id +'_driver_' + driver.id">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on"
                              @click.stop="$root.onShowUserPreview(driver.id, driver.fullName)"
                              style="cursor: pointer;"
                              class="ml-1"
                              :size="24"
                              :color="(driver.initials && !driver.avatarUPLOAD) ? '#015aaa' : null">
                      <v-img :src="$root.getImageUrl('avatar', driver.avatarUPLOAD)" v-if="driver.avatarUPLOAD"></v-img>
                      <span style="color:#fff;" v-else-if="driver.initials">{{driver.initials}}</span>
                      <v-icon large v-else>account_circle</v-icon>
                    </v-avatar>
                  </template>
                  <span>{{driver.fullName}}</span>
                </v-tooltip>
              </v-flex>
            </template>
          </v-layout>
        </template>

        <template v-slot:item.status="{ item }">
          <InvoiceStatusSnippet :item="item"></InvoiceStatusSnippet>
        </template>

        <template v-slot:item.name="{ item }">
          <div style="min-width:200px;">{{item.name}}</div>
          <template v-if="item.updateNumber > 0">
            <div class="text-no-wrap">
              {{$t('Version')}} {{item.updateNumber}}
            </div>
          </template>
        </template>

        <template v-slot:item.total="{ item }">
          ${{item.total}}
          <template v-if="parseInt(item.loadFinished) === 2"><br/><v-chip color="warning" small>TONU</v-chip></template>
        </template>

        <template v-slot:item.flatRate="{ item }">
          {{$root.moneyValue(item.accountingManagerPerInvoicePaymentFlat)}}
        </template>

        <template v-slot:item.percentRate="{ item }">
          {{$root.moneyValue(item.accountingManagerPerInvoicePaymentPercentRate)}}&nbsp;({{item.accountingManagerPerInvoicePaymentPercent || 0}}%)
        </template>

        <template v-slot:item.salary="{ item }">
          {{$root.moneyValue(item.accountingManagerPerInvoicePaymentFlat + item.accountingManagerPerInvoicePaymentPercentRate)}}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-layout v-if="$root.isFullFinancialDataAllowedToView">
            <v-flex shrink>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn  v-on="on"
                            :loading="item.loading"
                            :disabled="!item.isChecked"
                            @click.stop="onReportToggleChecked(item, item.id, accountantId, $store.getters.overriddenFieldsTypes.INVOICES, 100)"
                            icon
                            small>
                      <v-icon :color="item.isVerified ? 'success': null">mdi-check-all</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{item.isVerified ? ($t('Reports.MarkedAsVerified') + (item.verifiedDateTime ? ': ' + item.verifiedDateTime : '')) : $t('Reports.MarkAsVerified')}}
                  </span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex shrink>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn  v-on="on"
                            :loading="item.loading"
                            @click.stop="onReportToggleChecked(item, item.id, accountantId, $store.getters.overriddenFieldsTypes.INVOICES, 0)"
                            icon
                            small>
                      <v-icon small :color="item.isChecked ? 'success': null">mdi-check-decagram</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{item.isChecked ? ($t('Reports.MarkedAsChecked') + (item.checkedDateTime ? ': ' + item.checkedDateTime : '')) : $t('Reports.MarkAsChecked')}}
                  </span>
                </v-tooltip>
              </template>
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView">
        <v-flex xs12 class="text-right">
          <v-btn class="ma-1" :disabled="selectedItems.length === 0" @click="createReportGroup(0, lastReportsGroupNumber + 1, $route.params.type, from, to)"><v-icon left>mdi-clipboard-check-outline</v-icon> {{$t('Reports.CreateReportsGroup')}}</v-btn>
        </v-flex>
      </v-layout>-->

    </v-card>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import AccountantsReportTemplate from './AccountantsReportTemplate.vue';
import ReportActions from './../../components/ReportActions.vue';
import InvoiceStatusSnippet from './../../components/InvoiceStatusSnipet.vue';
import AccountantsTotals from "./AccountantsTotals.vue";
import invoicesMixin from "../../mixins/invoicesMixin";
import FiltersPanel from '../../components/FiltersPanel.vue';

export default {
  name: 'AccountantsReport',
  props: ['from', 'to', 'selectedStr', 'companyId', 'accountantId', 'reportData'],
  components: {AccountantsTotals, AccountantsReportTemplate, ReportActions, InvoiceStatusSnippet, FiltersPanel },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      selectedItems: [],
      totalsCounts: {
        totalCount: 0,
        totalPaid: 0,
        totalAmount: 0,
        totalFlatRate: 0,
        totalPercentRate: 0,
        totalSalary: 0,
        totalDrivers: {},
        totalTrucks: {}
      },
      totalsCountsNames: {
        totalCount: 'Total'
      },
      filterStatus: 'All',
      filterDispatcher: 'All',
      filterDriver: 'All',
      filterTruck: 'All',
      filterBroker: 'All',
      statusFilter: {
        name: 'filterStatus',
        label: 'Status',
        field: '',
        list: [
          { id: 'All', name: 'All' },
          { id: 'New', name: 'New' },
          { id: 'Ready', name: 'Ready' },
          { id: 'Verified', name: 'Verified' },
          { id: 'Pending', name: 'Pending' },
          { id: 'Pending', name: 'Pending' },
          { id: 'Paid', name: 'Paid' },
          { id: 'Underpaid', name: 'Underpaid' },
          { id: 'Not Paid', name: 'Not Paid' },
          { id: 'Overdue', name: 'Overdue' }
        ],
        multiple: true
      },
      dispatcherFilter: {
          name: 'filterDispatcher',
          label: 'Dispatcher',
          field: '',
          multiple: true,
          list: [
          ]
      },
      driverFilter: {
        name: 'filterDriver',
        label: 'Driver',
        field: '',
        multiple: true,
        list: [
        ]
      },
      truckFilter: {
        name: 'filterTruck',
        label: 'Truck',
        field: '',
        multiple: true,
        list: [
        ]
      },
      brokerFilter: {
        name: 'filterBroker',
        label: 'Broker',
        field: '',
        multiple: true,
        list: [
        ]
      },
      invoices: [],
      search: '',
      reportsGroupsListKey: new Date().getTime(),
      currentDateTime: 'N/A',
      headers: [
        { text: this.$root.t('Invoices.Number'), value: 'invoiceNumber' },
        { text: this.$root.t('Invoices.Status'), value: 'status' },
        { text: this.$root.t('Invoices.Creator'), value: 'created' },
        { text: this.$root.t('Invoices.Sender'), value: 'sentDate' },
        { text: this.$root.t('Invoices.Broker'), value: 'broker' },
        // { text: this.$root.t('Invoices.Created'), value: 'created' },
        // { text: this.$root.t('Invoices.name'), value: 'name' },
        { text: this.$root.t('Invoices.LoadUID'), value: 'loadUIDAndNumber' },
        { text: this.$root.t('Invoices.Amount'), value: 'total' },
        { text: this.$root.t('Reports.accountingManagerFlatRate'), value: 'flatRate' },
        { text: this.$root.t('Reports.accountingManagerPercentRate'), value: 'percentRate' },
        { text: this.$root.t('Reports.Salary'), value: 'salary' },
        { text: '', value: 'actions' }
      ],
      footer_props: {
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': '',
        'disable-items-per-page': false
      },
      accountantName: ''
    };
  },
  computed: {
  },
  mounted () {

    this.$root.setLastListPath(this.$route.path);

    // set saved user filter
    // if (this.$root.getLocalStorageItem('invoicesReportFilterStatus')) {
    //   this.statusFilter = this.$root.getLocalStorageItem('invoicesReportFilterStatus');
    // }

    this.$root.loadUserFields(this.accountantId).then (response => {
      if (response.status === 'ok') {
        this.accountantName = response.fields.firstName + ' ' + response.fields.lastName;
      }
    });

    this.setAccountantsTotalsHeaders();

    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    clearTotals () {
      this.totalsCounts = {
        totalCount: 0,
        totalPaid: 0,
        totalAmount: 0,
        totalFlatRate: 0,
        totalPercentRate: 0,
        totalSalary: 0,
        totalDrivers: {},
        totalTrucks: {}
      };
    },
    // statusFilterChanged () {
    //   if (this.statusFilter !== 'All') {
    //     this.$root.setLocalStorageItem('invoicesReportFilterStatus', this.statusFilter);
    //   } else {
    //     this.$root.removeFromLocalStorageItem('invoicesReportFilterStatus');
    //   }
    //   this.fetchData();
    // },
    onItemSelected () {
      this.$nextTick(() => {
        let selected = [];
        for (let i = 0; i < this.selectedItems.length; i++) {
          selected.push(parseInt(this.selectedItems[i]['id']));
        }
        this.$emit('selected', selected);
      });
    },
    rowClick (id, number) {
      if (!id || id === 0) return;
      // this.$root.route('/invoices/page/' + id);
      this.$root.onShowInvoicePreview(id, number);
    },
    onFilterChanged (e) {
      let i = 0;
      let field = '';
      let value = '';
      const filtersFields = Object.keys(e);
      for (i = 0; i < filtersFields.length; i++) {
        field = filtersFields[i];
        value = Object.prototype.hasOwnProperty.call(e, field) ? e[field] : null;
        if (value !== '') {
          this[field] = Array.isArray(value) ? value.join(',') : value;
        }
      }
      if (this.isFilterInitialized) {
        this.fetchData();
      }
      this.isFilterInitialized = true;
    },
    fetchData (skipSelected = false, selected = []) {
      let i = 0;
      let invoice = {};
      let fees = 0;
      let factoringFees = 0;
      if (!this.from || !this.to) return;

      return new Promise((resolve, reject) => {
        this.loading = true;
        this.getInvoicesReportData(this.from, this.to, this.filterTruck, this.filterDriver, this.filterDispatcher, this.filterStatus, this.filterBroker, this.accountantId).then((response) => {
          if (response.status === 'ok') {
            this.clearTotals();
            this.currentDateTime = response.currentDateTime;
            this.invoices = [];
            let selectedArray = [];
            if (!skipSelected && this.selectedStr) {
              selectedArray = this.selectedStr.split(',').map(v => {
                return parseInt(v);
              });
            }
            else if (!skipSelected && selected.length > 0) {
              for (let i = 0; i < selected.length; i++) {
                selectedArray.push(selected[i]);
              }
            }

            console.error(response.invoices);
            this.selectedItems = [];
            for (i = 0; i < response.invoices.length; i++) {
              invoice = response.invoices[i];
              invoice.totalWithoutFees = parseFloat(invoice.fees) > 0 ? (invoice.total - (invoice.total * (parseFloat(invoice.fees) / 100.0))) : invoice.total;

              console.error(invoice.id, selectedArray.indexOf(parseInt(invoice.id)));
              if (selectedArray.length > 0 && selectedArray.indexOf(parseInt(invoice.id)) < 0) continue;

              this.totalsCounts.totalCount += 1;
              this.totalsCounts.totalDrivers = Object.assign(this.totalsCounts.totalDrivers, invoice.driversData);
              this.totalsCounts.totalTrucks = Object.assign(this.totalsCounts.totalTrucks, invoice.trucksData);

              fees = 0;
              if (parseFloat(invoice.fees) > 0) {
                fees = invoice.total * parseFloat(invoice.fees) / 100;
              } else {
                fees = parseFloat(invoice.factoringScheduleFee) + parseFloat(invoice.factoringFee);
              }
              factoringFees = parseFloat((invoice.amountReceived > 0 ? invoice.amountReceived : invoice.total) * (invoice.factoring / 100.0));
              if (parseInt(invoice.factoring) >= 0) {
                factoringFees += fees;
              }

              invoice.expectToReceive = parseFloat(invoice.expectToReceive);
              invoice.factReceived = parseFloat(invoice.factReceived);
              invoice.amountReceived = parseFloat(invoice.amountReceived);
              invoice.amountUnderpaid = parseFloat(invoice.amountUnderpaid);

              this.totalsCounts.totalPaid += parseFloat(invoice.amountReceived) > 0 ? 1 : 0;

              this.totalsCounts.totalAmount += parseFloat(invoice.total);
              this.totalsCounts.totalFlatRate += parseFloat(invoice.accountingManagerPerInvoicePaymentFlat) ? parseFloat(invoice.accountingManagerPerInvoicePaymentFlat) : 0;
              this.totalsCounts.totalPercentRate += parseFloat(invoice.accountingManagerPerInvoicePaymentPercentRate) > 0 ? parseFloat(invoice.accountingManagerPerInvoicePaymentPercentRate) : 0;
              this.totalsCounts.totalSalary = this.totalsCounts.totalFlatRate + this.totalsCounts.totalPercentRate;

              invoice.loadUIDAndNumber = invoice.loadNumber + ' ' + invoice.loadUID;

              this.invoices.push(invoice);
            }
          }
          this.dispatcherFilter.list = [];
          for(let i = 0; i < response.dispatchers.length; i++) {
            this.dispatcherFilter.list.push({
              id: response.dispatchers[i].id,
              name: response.dispatchers[i].name
            })
          }
          this.driverFilter.list = [];
          for(let i = 0; i < response.drivers.length; i++) {
            this.driverFilter.list.push({
              id: response.drivers[i].id,
              name: response.drivers[i].name
            })
          }
          this.truckFilter.list = [];
          for(let i = 0; i < response.trucks.length; i++) {
            this.truckFilter.list.push({
              id: response.trucks[i].id,
              name: response.trucks[i].name
            })
          }
          this.brokerFilter.list = [];
          this.reportsGroupsListKey = 'reportsGroupsListKey' + new Date().getTime();
          this.onItemSelected();
          this.$forceUpdate();
          this.loading = false;
          resolve(this.totalsCounts);
        });
      });
    }
  }
};
</script>
